import cx from 'classnames';
import _ from 'lodash';
import { ElementType, forwardRef } from 'react';
import {
  Button as BootstrapButton,
  ButtonProps as BootstrapButtonProps,
} from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import css from './Button.module.scss';

export type ButtonProps = BootstrapButtonProps & {
  as?: ElementType;
  color?: 'blue' | 'orange' | 'black' | 'green' | 'red';
  isLoading?: boolean;
  isPressed?: boolean;
  isRounded?: boolean;
};

export const Button = forwardRef(
  (
    {
      className,
      children,
      disabled,
      isLoading,
      isPressed,
      isRounded,
      ...rest
    }: ButtonProps,
    ref
  ) => (
    <BootstrapButton
      // @ts-ignore - TypeScript doesn't like the `...rest` spread here.
      aria-pressed={_.isBoolean(isPressed) ? isPressed : undefined}
      className={cx(css.button, className, {
        [css.rounded]: isRounded,
      })}
      disabled={disabled || isLoading}
      ref={ref}
      {...rest}
    >
      {isLoading ? (
        <Spinner
          animation="border"
          aria-hidden="true"
          as="span"
          className="mr-2"
          role="status"
          size="sm"
        />
      ) : (
        children
      )}
    </BootstrapButton>
  )
);

Button.displayName = 'Button';
